"use client";

import { useSyncExternalStore } from "react";

/**
 * `false` during SSR and the hydration pass, `true` from the client onwards.
 *
 * Every page in this app gates its first data fetch on this, so that the
 * server-rendered markup and the hydration render agree (the fetch depends on
 * auth state that only exists in the browser). The older shape — `useState(false)`
 * plus `useEffect(() => setMounted(true), [])` — expresses the same thing but
 * sets state synchronously in an effect, which React flags
 * (`react-hooks/set-state-in-effect`) because it forces a second render pass.
 *
 * `useSyncExternalStore` states the server/client split directly and lets React
 * handle the hydration boundary. The snapshots are module-level constants so the
 * returned value is referentially stable — a fresh value per call would loop.
 */

/** Nothing ever changes after hydration, so there is no store to subscribe to. */
function subscribe(): () => void {
  return () => {};
}

function getClientSnapshot(): boolean {
  return true;
}

function getServerSnapshot(): boolean {
  return false;
}

export function useMounted(): boolean {
  return useSyncExternalStore(subscribe, getClientSnapshot, getServerSnapshot);
}
